'use client';

import Phone from '@/assets/icons/cart/call.svg';
import Logotype from '@/assets/icons/radius_qora_logo.svg';
import ArrowLeft from '@/assets/icons/icon-arrow-left.svg';
import {
  CustomCitiesSelect,
  GiftCard,
  PasswordContent,
  PersonalCabinet,
} from '@/components';
import CardComponent from '@/components/shared/card';
import CardTotal from '@/components/shared/cardTotal';
import EmptyData from '@/components/shared/emptyData';
import PlacingOrder from '@/components/shared/placingOrder';
import ProductAccardion from '@/components/shared/productAccardion';
import BestBuy from '@/components/ui/best-buy';
import { useDraftOrderQuery, useUserDraftOrdersQuery } from '@/graphql';
import convertToReadable from '@/helpers/convertToReadable';
import formatPhoneNumber from '@/helpers/formatPhoneNumber';
import { mapEdgesToItems } from '@/helpers/maps';
import useHasMounted from '@/hooks/useHasMounted';
import { Link, useRouter } from '@/i18n/navigation';
import { useGuestStore } from '@/zustand/guestStore';
import useAuthModal from '@/zustand/useAuthModal';
import useUserStore from '@/zustand/useUser';
import { useTranslations } from 'next-intl';
import React, { useEffect, useRef, useState } from 'react';
import { MdOutlineKeyboardBackspace } from 'react-icons/md';
import { useWindowSize } from 'react-use';
import { Header, Modal, Text } from 'rsuite';
import FixedMobileNavbar from '../fixed-mobile-navbar';
import styles from './cartPage.module.scss';
import { CartSkeleton } from './cartSkeleton';
import CartModal from './modal/cartModal';

type Props = {};

export default function Cart({}: Props) {
  const [cartModal, setCartModal] = useState(false);
  const [showAd, setShowAd] = useState(true);
  const [showFixedButtons, setShowFixedButtons] = useState(true);
  const { width } = useWindowSize();
  const userData = useUserStore((user: any) => user?.user);
  const isLoggedIn = userData?.id;
  const orderId = useGuestStore(state => state.guestOrderId);
  // const city = useCityStore((state) => state.selectedCity);
  const router = useRouter();
  const hasMounted = useHasMounted();
  const { isPopoverOpen, setPopoverOpen } = useAuthModal();
  const [openModal, setOpenModal] = useState(false);
  const [auth, setAuth] = useState(false);
  const triggerRef = useRef<any>();
  const t = useTranslations('CartPage');
  const {
    data: draftOrdersData,
    refetch: refetchDraftOrders,
    loading: isUserLoading,
  } = useUserDraftOrdersQuery({
    variables: {
      userId: userData?.id,
    },
  });

  const {
    data: guestDraftOrdersData,
    loading: isGuestLoaiding,
    refetch: refetchGuestDraftOrdersData,
  } = useDraftOrderQuery({
    variables: {
      id: orderId || '',
    },
    skip: !orderId,
  });

  const handleOrderClick = () => {
    // if (isLoggedIn) {
    //   router.push("/order");
    //   //handleClose?.();
    // } else {
    //   triggerRef.current?.open?.();
    //   setPopoverOpen(true);
    // }
    if (isLoggedIn) {
      router.push('/order');
      //handleClose?.();
    } else {
      triggerRef.current?.open?.();
      setOpenModal(true);
      setPopoverOpen(true);
    }
  };

  const phone =
    draftOrdersData?.userDraftOrders?.[0]?.user?.phone || '+998 (71) 200 31 00';

  const similarProducts =
    mapEdgesToItems(
      isLoggedIn
        ? draftOrdersData?.userDraftOrders?.[0]?.linesSimilarProducts
        : guestDraftOrdersData?.draftOrder?.linesSimilarProducts
    ) || [];

  const isGiftProduct = (
    isLoggedIn
      ? draftOrdersData?.userDraftOrders?.[0]?.lines
      : guestDraftOrdersData?.draftOrder?.lines
  )?.some(line => line?.variant?.gifts?.length);

  const totalPrice =
    (isLoggedIn
      ? draftOrdersData?.userDraftOrders?.[0]?.lines
      : guestDraftOrdersData?.draftOrder?.lines
    )?.reduce((total, lineItem) => {
      if (lineItem?.isGift) {
        return total;
      }

      const price = lineItem?.variant?.pricing?.price?.net?.amount || 0;
      const quantity = lineItem?.quantity || 1;

      return total + price * quantity;
    }, 0) || 0;

  useEffect(() => {
    const guestCart = Boolean(guestDraftOrdersData?.draftOrder);

    if (!isUserLoading && guestCart === false) {
      useGuestStore.getState().clearGuestOrderId();
    }
  }, [guestDraftOrdersData?.draftOrder, isGuestLoaiding]);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      const isNearBottom = documentHeight - (scrollTop + windowHeight) < 200;
      setShowFixedButtons(!isNearBottom);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div>
      {width > 768 && (
        <div className={styles.headerTop}>
          <div className={styles.headerTopWraper}>
            <div className={styles.link} onClick={() => router.push('/')}>
              <div>
                <MdOutlineKeyboardBackspace className={styles.headerTopIcon} />
              </div>
              <h6 className={styles.headerTopText}>{t('back-to-shopping')}</h6>
            </div>
            <div className={styles.headerLogo}>
              <Logotype />
            </div>

            <div className={styles.rightFlex}>
              {/* <SelectPicker
                data={cityOptions}
                searchable={false}
                value={city.toLocaleUpperCase()}
                style={{ width: 150 }}
                placeholder=""
                className={`${styles.select} customSelect`}
              /> */}
              <CustomCitiesSelect />

              <p className={styles.phoneNumber}>
                {width <= 580 ? (
                  <Link href="tel:phone">
                    <Phone className={styles.phoneNumberIcon} />
                  </Link>
                ) : (
                  phone && formatPhoneNumber(phone)
                )}
              </p>
            </div>
          </div>
        </div>
      )}
      <div className={`${styles.root} container`}>
        {isUserLoading || isGuestLoaiding ? (
          <div className={styles.skeletonWrapper}>
            <CartSkeleton />
          </div>
        ) : (isLoggedIn
            ? (draftOrdersData?.userDraftOrders?.[0]?.lines?.length ?? 0)
            : (guestDraftOrdersData?.draftOrder?.lines?.length ?? 0)) > 0 ? (
          <div>
            {width > 768 && (
              <div className={styles.headerContainer}>
                <div className={styles.leftFlex}>
                  <Header className={styles.header}>
                    {t('title')}{' '}
                    <span>
                      {isLoggedIn
                        ? draftOrdersData?.userDraftOrders?.[0] &&
                          draftOrdersData?.userDraftOrders?.[0]?.lines?.length >
                            0
                          ? draftOrdersData?.userDraftOrders?.[0]?.lines?.length
                          : 0
                        : (guestDraftOrdersData?.draftOrder?.lines.length ??
                          0)}{' '}
                      {t('products')}
                    </span>
                  </Header>
                </div>
              </div>
            )}
            {width <= 768 && (
              <div className={styles.headerTop}>
                <div className={styles.headerTopWraper}>
                  <div className={styles.link} onClick={() => router.push('/')}>
                    <ArrowLeft className={styles.headerTopIcon} />
                  </div>
                  <div className={styles.headerContainer}>
                    <div className={styles.leftFlex}>
                      <Header className={styles.header}>
                        {t('title')}{' '}
                        <span>
                          {isLoggedIn
                            ? draftOrdersData?.userDraftOrders?.[0] &&
                              draftOrdersData?.userDraftOrders?.[0]?.lines
                                ?.length > 0
                              ? draftOrdersData?.userDraftOrders?.[0]?.lines
                                  ?.length
                              : 0
                            : (guestDraftOrdersData?.draftOrder?.lines.length ??
                              0)}{' '}
                          {t('products')}
                        </span>
                      </Header>
                    </div>
                  </div>
                  <div className={styles.rightFlex}>
                    {/* <CustomCitiesSelect /> */}

                    <p className={styles.phoneNumber}>
                      {width <= 580 ? (
                        <Link href="tel:phone">
                          <Phone className={styles.phoneNumberIcon} />
                        </Link>
                      ) : (
                        phone && formatPhoneNumber(phone)
                      )}
                    </p>
                  </div>
                </div>
              </div>
            )}
            <div className={styles.mobileCity}>
              <div className={styles.mobileCityLeft}>
                <Text className={styles.mobileCityText}>{t('your-city')}:</Text>

                <CustomCitiesSelect />
              </div>
              {hasMounted && (
                <button className={styles.nextButton}>
                  <ArrowLeft className={styles.nextButtonIcon} />
                </button>
              )}
            </div>

            <div className={styles.cardsection}>
              <div className={styles.cardsection}>
                <div className={styles.cardWrapper}>
                  {/* {showAd && (
                    <div className={styles.adsection}>
                      <Ad setShowAd={setShowAd} />
                    </div>
                  )} */}
                  {
                    <div className={styles.cards}>
                      {(isLoggedIn
                        ? draftOrdersData?.userDraftOrders?.[0]?.lines
                        : guestDraftOrdersData?.draftOrder?.lines
                      )?.map(order => {
                        if (
                          order?.variant?.gifts?.length === 0 &&
                          !order?.isGift
                        ) {
                          return (
                            <div key={order?.id} className={styles.cardItem}>
                              <CardComponent
                                orderId={
                                  isLoggedIn
                                    ? draftOrdersData?.userDraftOrders?.[0]?.id
                                    : guestDraftOrdersData?.draftOrder?.id
                                }
                                data={order}
                                refetchDraftOrders={refetchDraftOrders}
                                refetchGuestDraftOrders={
                                  refetchGuestDraftOrdersData
                                }
                                gusetBasketLine={
                                  guestDraftOrdersData?.draftOrder?.lines
                                }
                              />
                            </div>
                          );
                        }
                      })}
                    </div>
                  }
                  {isGiftProduct ? (
                    <div className={styles.complectProducts}>
                      {
                        <div className={styles.cards}>
                          <div className={styles.cardItem}>
                            <h3>{t('set-gifts')}</h3>
                          </div>
                          {(isLoggedIn
                            ? draftOrdersData?.userDraftOrders?.[0]?.lines
                            : guestDraftOrdersData?.draftOrder?.lines
                          )?.map(order => {
                            if (
                              order?.variant?.gifts &&
                              order?.variant?.gifts?.length > 0
                            ) {
                              return (
                                <React.Fragment key={order?.id}>
                                  <div className={styles.cardItem}>
                                    <CardComponent
                                      orderId={
                                        isLoggedIn
                                          ? draftOrdersData
                                              ?.userDraftOrders?.[0]?.id
                                          : guestDraftOrdersData?.draftOrder?.id
                                      }
                                      data={order}
                                      refetchDraftOrders={refetchDraftOrders}
                                      refetchGuestDraftOrders={
                                        refetchGuestDraftOrdersData
                                      }
                                      gusetBasketLine={
                                        guestDraftOrdersData?.draftOrder?.lines
                                      }
                                    />
                                  </div>
                                  {order?.variant?.gifts?.map(gift => {
                                    return (
                                      <div
                                        key={order?.id}
                                        className={styles.cardItem}
                                      >
                                        <GiftCard
                                          orderId={
                                            isLoggedIn
                                              ? draftOrdersData
                                                  ?.userDraftOrders?.[0]?.id
                                              : guestDraftOrdersData?.draftOrder
                                                  ?.id
                                          }
                                          data={gift}
                                          refetchDraftOrders={
                                            refetchDraftOrders
                                          }
                                          refetchGuestDraftOrders={
                                            refetchGuestDraftOrdersData
                                          }
                                          gusetBasketLine={
                                            guestDraftOrdersData?.draftOrder
                                              ?.lines
                                          }
                                        />
                                      </div>
                                    );
                                  })}
                                </React.Fragment>
                              );
                            }
                          })}
                        </div>
                      }

                      <div className={styles.cardFooter}>
                        <Text className={styles.cardFooterText}>
                          {t('price-per-set')}
                        </Text>
                        <Text className={styles.cardTotalPrice}>
                          {convertToReadable(totalPrice)} {t('price')}
                        </Text>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  <div>
                    <ProductAccardion
                      refetchDraftOrders={
                        isLoggedIn
                          ? refetchDraftOrders
                          : refetchGuestDraftOrdersData
                      }
                      draftOrdersData={
                        isLoggedIn ? draftOrdersData : guestDraftOrdersData
                      }
                      similarProducts={similarProducts}
                    />
                  </div>
                  <div className={styles.mobileCardTotal}>
                    <CardTotal
                      modalOpen={() => setCartModal(true)}
                      guest={isLoggedIn}
                      orderData={
                        isLoggedIn
                          ? draftOrdersData?.userDraftOrders?.[0]
                          : guestDraftOrdersData?.draftOrder
                      }
                    />
                  </div>
                  {
                    <div style={{ marginTop: '12px' }}>
                      <PlacingOrder
                        userData={userData}
                        modalOpen={() => setCartModal(true)}
                        orderData={draftOrdersData}
                      />
                    </div>
                  }
                </div>

                <div className={styles.desctopCardTotal}>
                  <CardTotal
                    modalOpen={() => setCartModal(true)}
                    guest={isLoggedIn}
                    orderData={
                      isLoggedIn
                        ? draftOrdersData?.userDraftOrders?.[0]
                        : guestDraftOrdersData?.draftOrder
                    }
                  />
                </div>
              </div>
            </div>
            {width <= 768 && showFixedButtons && (
              <div className={styles.fixedButtons}>
                <div className={styles.textWrapper}>
                  <Text className={styles.totalPrice}>
                    {convertToReadable(totalPrice)} {t('price')}
                  </Text>
                  <Text className={styles.quantityProducts}>
                    {isLoggedIn
                      ? draftOrdersData?.userDraftOrders?.[0] &&
                        draftOrdersData?.userDraftOrders?.[0]?.lines?.length > 0
                        ? draftOrdersData?.userDraftOrders?.[0]?.lines?.length
                        : 0
                      : (guestDraftOrdersData?.draftOrder?.lines.length ??
                        0)}{' '}
                    {t('products')}
                  </Text>
                </div>
                <div className={styles.buttonsWrapper}>
                  <button
                    className={styles.orangeButton}
                    onClick={handleOrderClick}
                  >
                    {t('formalize')}
                  </button>
                  <button
                    onClick={() => setCartModal(true)}
                    className={styles.grayButton}
                    disabled={
                      draftOrdersData?.userDraftOrders?.[0]
                        ?.installmentsWithoutIntegration.length === 0
                    }
                  >
                    {t('formalize-credit')}
                  </button>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className={styles.emptyCartWrapper}>
            {width <= 768 && (
              <div className={styles.headerTop}>
                <div className={styles.headerTopWraper}>
                  <div className={styles.link} onClick={() => router.push('/')}>
                    <ArrowLeft className={styles.headerTopIcon} />
                  </div>
                  <div className={styles.headerContainer}>
                    <div className={styles.leftFlex}>
                      <Header className={styles.header}>
                        {t('title')}{' '}
                        <span>
                          {isLoggedIn
                            ? draftOrdersData?.userDraftOrders?.[0] &&
                              draftOrdersData?.userDraftOrders?.[0]?.lines
                                ?.length > 0
                              ? draftOrdersData?.userDraftOrders?.[0]?.lines
                                  ?.length
                              : 0
                            : (guestDraftOrdersData?.draftOrder?.lines.length ??
                              0)}{' '}
                          {t('products')}
                        </span>
                      </Header>
                    </div>
                  </div>
                  <div className={styles.rightFlex}>
                    {/* <CustomCitiesSelect /> */}

                    <p className={styles.phoneNumber}>
                      {width <= 580 ? (
                        <Link href="tel:phone">
                          <Phone className={styles.phoneNumberIcon} />
                        </Link>
                      ) : (
                        phone && formatPhoneNumber(phone)
                      )}
                    </p>
                  </div>
                </div>
              </div>
            )}
            <EmptyData
              text={t('empty-data.text')}
              subText={t('empty-data.subtext')}
              buttonText={t('empty-data.button-text')}
            />
            <div className={styles.cardsSection}>
              <BestBuy title={t('sales-hits')} />
            </div>
          </div>
        )}
      </div>
      {cartModal && (
        <CartModal
          open={cartModal}
          close={() => setCartModal(false)}
          data={draftOrdersData}
        />
      )}
      {width <= 768 && <FixedMobileNavbar />}
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        // size="sm"
        className={styles.modalCentered}
        backdrop="static"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {auth ? (
          <div className={styles.cabinetWrapper}>
            <PasswordContent onClose={() => setOpenModal(false)} />
          </div>
        ) : (
          <PersonalCabinet
            authWrapper={true}
            isGuest={true}
            handleOpen={() => setOpenModal(true)}
            handleClose={() => setOpenModal(false)}
            setAuth={() => setAuth(true)}
          />
        )}
      </Modal>
    </div>
  );
}
